import { Injectable, inject } from '@angular/core'
import { AccountObject } from '@tradecafe/types/core'
import { DeepReadonly } from '@tradecafe/types/utils'
import { ModalService } from 'src/shared/modal'
import { CreateBuyerGroupDialogComponent, CreateBuyerGroupDialogData } from './create-buyer-group-dialog.component'

@Injectable()
export class CreateBuyerGroupService {
  private readonly modal = inject(ModalService)


  showCreateBuyerGroup(selectedCompanies: DeepReadonly<AccountObject>[]) {
    return this.modal.openDialog<
      CreateBuyerGroupDialogComponent,
      CreateBuyerGroupDialogData,
      boolean
    >(
      CreateBuyerGroupDialogComponent,
      { selectedCompanies },
    ).toPromise()
  }
}
